export function fullScreenLoader() {
    // 이미 존재하면 다시 만들지 않음
    if (document.getElementById("full-screen-loader")) {
        return document.getElementById("full-screen-loader")!;
    }

    const loader = document.createElement("div");
    loader.id = "full-screen-loader";
    loader.style.position = "fixed";
    loader.style.top = "0";
    loader.style.left = "0";
    loader.style.width = "100%";
    loader.style.height = "100%";
    loader.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    loader.style.display = "flex";
    loader.style.justifyContent = "center";
    loader.style.alignItems = "center";
    loader.style.zIndex = "9999";

    const spinner = document.createElement("div");
    spinner.className = "loader";
    spinner.style.setProperty("--loader-color", "white");
    spinner.style.setProperty("--loader-size", "12px");
    loader.appendChild(spinner);

    if (document.body) {
        return document.body.appendChild(loader);
    } else {
        // body가 없으면 html에 직접 추가
        return document.documentElement.appendChild(loader);
    }
}

export function removeFullScreenLoader() {
    const loaderElement = document.getElementById("full-screen-loader");
    if (loaderElement) {
        document.body.removeChild(loaderElement);
    }
}
